import { render, staticRenderFns } from "./DishRestaurant.vue?vue&type=template&id=4f42c0b5&"
import script from "./DishRestaurant.vue?vue&type=script&lang=js&"
export * from "./DishRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./DishRestaurant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports